import { Injectable } from '@angular/core';

type NavigationTrigger = 'imperative' | 'popstate' | 'hashchange';

/** Contexto de la navegación en curso, sin inyectar Router en RouteReuseStrategy (evita NG0200). */
@Injectable({ providedIn: 'root' })
export class ListNavigationContextService {
  private trigger: NavigationTrigger = 'imperative';
  private state: unknown = null;

  capture(trigger: NavigationTrigger, state: unknown): void {
    this.trigger = trigger;
    this.state = state;
  }

  getTrigger(): NavigationTrigger {
    return this.trigger;
  }

  getState(): unknown {
    return this.state;
  }

  clear(): void {
    this.trigger = 'imperative';
    this.state = null;
  }
}
